// eslint-disable-next-line import/no-unresolved
import { CustomerSucessController } from "@talentbait/shared-components";

import logger from "../../../utils/LoggerFrontend";
import CampaignMembersActions from "../CampaignMembers.actions";

import { updateMemberRole } from "../CampaignMembers.utils";
import {
  ROLE_OWNER,
  ROLE_RECRUITER,
  ROLE_SUBSCRIBER_ATS,
  ROLE_SUBSCRIBER_CAMPAIGN
} from "../CampaignMembers.constants";

function useUpdateCampaignMembers({
  campaignId,
  campaignMembers,
  handleCloseModal,
  ownerId,
  recruiterId,
  setChangesHaveBeenMade,
  subscribersAtsIds,
  subscribersCampaignIds,
  addedSubscribersAts,
  addedSubscribersCampaign
}) {
  const handleSubmit = () => {
    logger.log("useUpdateCampaignMembers:handleSubmit", "called", {
      newCampaignMembers,
      addedSubscribersAts,
      addedSubscribersCampaign
    });
    CustomerSucessController.send(`CampaignMembers:updated`, { campaignId, newCampaignMembers });

    setChangesHaveBeenMade(false);

    const ref = CampaignMembersActions.updateCampaignMembers.completed.listen(() => {
      handleCloseModal();
      ref();
    });

    let newCampaignMembers = campaignMembers;

    newCampaignMembers = updateMemberRole({
      members: newCampaignMembers,
      membersIds: [ownerId],
      role: ROLE_OWNER
    });

    newCampaignMembers = updateMemberRole({
      members: newCampaignMembers,
      membersIds: [recruiterId],
      role: ROLE_RECRUITER
    });

    newCampaignMembers = updateMemberRole({
      members: newCampaignMembers,
      membersIds: subscribersCampaignIds,
      role: ROLE_SUBSCRIBER_CAMPAIGN
    });

    newCampaignMembers = updateMemberRole({
      members: newCampaignMembers,
      membersIds: subscribersAtsIds,
      role: ROLE_SUBSCRIBER_ATS
    });

    CampaignMembersActions.updateCampaignMembers(
      campaignId,
      newCampaignMembers,
      addedSubscribersAts,
      addedSubscribersCampaign
    );
  };

  return { handleSubmit };
}

export default useUpdateCampaignMembers;
